import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';


import { AuthGuard } from './services/auth-guard';
import { SearchComponent } from './components/search/search';
import { Login } from './components/login/login';
import { Forms } from './components/forms/forms';
import { DetailComponent } from './components/detail/detail';
import { SearchDocusignComponent } from './components/search-docusign/search-docusign';
import { SearchSterlingComponent } from './components/search-sterling/search-sterling';
import { SterlingDetailComponent } from './components/sterling-form/sterling-form';

const appRoutes: Routes = [
  { path: 'login',  component: Login },
  { path: 'search', component: SearchComponent, canActivate: [AuthGuard]},
  { path: 'detail/:id', component: DetailComponent, canActivate: [AuthGuard]},
  { path: '**', component: SearchComponent, canActivate: [AuthGuard] }
];

export const appRoutingProviders: any[] = [AuthGuard];

export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes, { useHash: false });



// WEBPACK FOOTER //
// ./src/app/app.routing.ts